<script>
export default {
    name: "InventoryEditForm",

    data() {

        return {
            active: 0,
            filter:{
                date: window.moment().format('YYYY-MM-DD'),
                storeId:0,
                itemId:0
            },
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`, 
        };
    },

    props: {
        show: Boolean,
        itemdetails: Object,
        itemtransactions: Array,
        storagelocation: Array,
       
    },

    computed: {

       
    },

    methods: {

       
          fetchInventoryTransactions () {
 let url = `Inventory/ItemTransactions?itemID=${this.itemdetails.itemID}`;
              url += `&StoreID=${this.filter.storeId}`;
              url += `&From=${this.filter.date}`;

           return this.$accountsHttp.get(url)
            .then(({ data }) => { this.itemtransactions = data; }).catch(() => {});
       },
 
    },
}
</script>

<template>
    <tail-modal :show="show" dimension="md:w-3/4 w-full">
        <template v-slot:title>
            <h5 class="font-medium text-sm"> Inventory Transactions</h5>
        </template>
        <template v-slot:modal-body>
             <div class="w-full flex flex-wrap items-center">
                    <div class="w-full flex flex-wrap bg-gray-300 p-2 mb-2">
            <div class="flex-1">
                <h5 class="font-medium text-sm">Group:{{itemdetails.groupName}} </h5>
            </div>
           
            <div class="flex-1">
                <h5 class="font-medium text-sm">Type : {{ itemdetails.typeName}}</h5>
            </div> <div class="flex-1">
                <h5 class="font-medium text-sm">Item Name: {{itemdetails.itemName }}</h5>
            </div>
            
        </div>  <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">As From:</label>
                   </div>
                        <div class="w-1/4 p-tiny">
                           <input type="date" v-model.trim="filter.date" 
                    id="grid-date-from" class="input-control input-sm text-xs">   </div>
                       
                        <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">Store:</label>
                   </div> <div class="w-1/4 p-tiny">
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.storeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select store</option>
                            <option v-for="store in storagelocation" 
                                :key="store.id" :value="store.id">{{ store.name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div> <div class="w-1/4 p-tiny pl-2">
                            <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchInventoryTransactions"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
              <div class="w-full overflow-auto my-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr>
                        
                        <th class="p-tiny border">Date</th>
                        <th class="p-tiny border">Description</th>
                        <th class="p-tiny border">User</th>
                        <th class="p-tiny border">Debit</th>
                        <th class="p-tiny border">Credit</th>
                        <th class="p-tiny border">Running Balance</th> 
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr  v-for="(itm, idx) in itemtransactions" :key="idx">
                         <td class="p-tiny">{{ itm.date| dateFormat}}</td>
                         <td class="p-tiny">{{ itm.description}}</td>
                         <td class="p-tiny">{{ itm.userName }}</td>
                         <td class="p-tiny">{{ itm.addition }}</td>
                        <td class="p-tiny">{{ itm.deduction }}</td>
                        <td class="p-tiny">{{ itm.runningBalance }}</td> 
                        </tr>
                     
                </tbody>
            </table>
        </div>
        </template>
        <template v-slot:modal-footer>
           <button class="btn-danger btn-sm text-xs rounded mr-8" @click.stop="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
           <!-- <button class="btn-primary btn-sm text-xs rounded" @click.prevent="updateData"><i class="fa fa-save"></i> Update</button>
       <button
                @click.prevent="printOrder"
                class="btn-info btn-sm text-xs rounded">
                    <i class="fa fa-print"></i> Print</button> -->
        </template>
    </tail-modal>
</template>
